(() => {
  if (window.VRSVWompiCheckoutInitialized) return;
  window.VRSVWompiCheckoutInitialized = true;

  const getStandardButton = (wompiButton) =>
    wompiButton.closest('product-form')?.querySelector('[id^="ProductSubmitButton-"]');

  const syncButtonState = (wompiButton) => {
    const standardButton = getStandardButton(wompiButton);
    if (!standardButton) return;

    const disabled =
      standardButton.disabled ||
      standardButton.getAttribute('aria-disabled') === 'true';

    wompiButton.disabled = disabled;
    wompiButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  };

  const bindButton = (wompiButton) => {
    if (wompiButton.dataset.vrsvBound === 'true') return;
    wompiButton.dataset.vrsvBound = 'true';

    const standardButton = getStandardButton(wompiButton);
    syncButtonState(wompiButton);

    if (standardButton) {
      new MutationObserver(() => syncButtonState(wompiButton)).observe(standardButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });
    }
  };

  const initializeButtons = (root = document) => {
    if (root.matches?.('[data-vrsv-wompi-checkout]')) bindButton(root);
    root.querySelectorAll?.('[data-vrsv-wompi-checkout]').forEach(bindButton);
  };

  const showError = (productForm, message) => {
    const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');
    const text = productForm?.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.hidden = false;
  };

  const setLoading = (button, loading) => {
    button.setAttribute('aria-disabled', loading ? 'true' : 'false');
    button.classList.toggle('loading', loading);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vrsv-wompi-checkout]');
    if (!button) return;

    event.preventDefault();

    const productForm = button.closest('product-form');
    const form = button.closest('form');
    const standardButton = getStandardButton(button);

    if (!form || !productForm || standardButton?.disabled || standardButton?.getAttribute('aria-disabled') === 'true') {
      return;
    }

    setLoading(button, true);

    try {
      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = new FormData(form);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add', config);
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'No se pudo agregar el producto. Inténtalo nuevamente.');
      }

      window.location.assign('/checkout');
    } catch (error) {
      showError(productForm, error.message || 'No se pudo iniciar el pago. Inténtalo nuevamente.');
      setLoading(button, false);
      syncButtonState(button);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeButtons());
  } else {
    initializeButtons();
  }

  document.addEventListener('shopify:section:load', (event) => initializeButtons(event.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initializeButtons(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
